import api from '../utils/api';

const reportService = {

  getPdfBlobUrl: async (caseId) => {
    // Step 1: trigger generation if needed
    const { data } = await api.get(`/reports/${caseId}/download/`);

    console.log('download response:', data); // keep for debug

    // Step 2: ALWAYS fetch as authenticated blob via /serve/
    // Never use the raw URL directly — it won't work without auth
    const pdfResp = await api.get(`/reports/${caseId}/serve/`, {
      responseType: 'blob',
    });

    const contentType = pdfResp.headers?.['content-type'] || '';
    console.log('serve content-type:', contentType); // keep for debug

    if (!contentType.toLowerCase().includes('pdf')) {
      throw new Error(`Expected PDF, got: ${contentType}`);
    }

    const blob = new Blob([pdfResp.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    console.log('created blob url:', url); // keep for debug
    return url;
  },

  getPdfBlob: async (caseId) => {
    // Trigger generation first
    await api.get(`/reports/${caseId}/download/`);

    // Always fetch as blob via authenticated endpoint
    const pdfResp = await api.get(`/reports/${caseId}/serve/`, {
      responseType: 'blob',
    });

    const contentType = pdfResp.headers?.['content-type'] || '';
    if (!contentType.toLowerCase().includes('pdf')) {
      throw new Error(`Expected PDF, got: ${contentType}`);
    }

    return pdfResp.data;
  },
};

export default reportService;